import classNames from 'classnames';
import React from 'react';

import { FormControl, FormHelperText, Grid } from '@material-ui/core';
import { RatingProps } from '@material-ui/lab';

import { useErrorStyles } from '../form.styles';
import { LabelBlock } from '../index';
import { StyledRating, useStyles } from './RatingStars.styles';
import StarIcon from './components/StarIcon';

type RatingStarsProps = {
  name: string;
  error?: string;
  label?: string;
  value?: string;
  tooltip?: string;
  required?: boolean;
  isErrorVisible: boolean;
  onChange: RatingProps['onChange'];
  innerRef?: React.MutableRefObject<HTMLInputElement | null>;
};

const RatingStars: React.FC<RatingStarsProps> = (props) => {
  const {
    name,
    label,
    error,
    value,
    tooltip,
    required = false,
    onChange,
    isErrorVisible,
    innerRef,
  } = props;

  const { input, starsContainer } = useStyles();
  const { errorFont, errorBlock } = useErrorStyles();

  return (
    <FormControl fullWidth className={input}>
      <LabelBlock
        label={label}
        required={required}
        tooltip={tooltip}
        error={error}
        isErrorVisible={isErrorVisible}
      />
      <Grid className={starsContainer}>
        <StyledRating
          name={name}
          value={parseInt(value ?? '0')}
          onChange={onChange}
          size="large"
          emptyIcon={<StarIcon />}
          icon={<StarIcon fill />}
          ref={innerRef}
        />
      </Grid>
      {error && (
        <FormHelperText className={classNames(errorFont, errorBlock)}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default RatingStars;
